import axios from "../../../axios";
import simpleAxios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * Get Subscriptions
 */
export const getSubscriptions = createAsyncThunk(
  "getSubscriptions",
  async () => {
    try {
      const { data } = await axios.get("/subscriptions");

      //
      let plans = data.result;

      //
      return plans;
    } catch (error) {
      return false;
    }
  }
);

/**
 * Create Invoice
 * @param {payType, {product_id, token (if payType is creadit_card), auto_renew}} payload
 */
export const createInvoice = async (payload) => {
  try {
    const { data } = await axios.post(
      `/payments/${payload.payType}/invoice`,
      payload.content
    );

    //
    let result = data.result;

    //
    return result;
  } catch (error) {
    return false;
  }
};

/**
 * Create Invoice
 * @param {payType, {product_id, token (if payType is creadit_card), auto_renew}} payload
 */
export const createProductInvoice = async (payload) => {
  try {
    const { data } = await axios.post(
      `/payments/${payload.payType}/shopInvoice`,
      payload.content
    );

    //
    let result = data.result;

    //
    return result;
  } catch (error) {
    return false;
  }
};

export const createCeckoutID = async (payload) => {
  let apiKey = process.env.REACT_APP_COINBASE_API_KEY;
  try {
    const { data } = await simpleAxios({
      method: "post", //you can set what request you want to be
      url: "https://api.commerce.coinbase.com/charges",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        "X-CC-Api-Key": apiKey,
        "X-CC-Version": "2018-03-22",
      },
    });

    //
    let coinbaseData = data.data;

    //
    return coinbaseData;
  } catch (error) {
    return false;
  }
};

/**
 * Get Transactions
 */
export const getTransactions = async () => {
  try {
    const { data } = await axios.get("/payments/transactions");

    //
    let list = data.result;

    //
    return list;
  } catch (error) {
    return false;
  }
};

/**
 * Get Current Method
 */
export const getCurrentMethod = async () => {
  try {
    const { data } = await axios.get("/payments/current-method");

    //
    let method = data.result;

    //
    return method;
  } catch (error) {
    return false;
  }
};

/**
 * Check Discount Coupon
 * @param {{product_id, coupon}} payload
 */
export const checkDisacountCode = async (payload) => {
  try {
    const { data } = await axios.post("/payments/check-coupon", payload);

    //
    let price = data.result;

    //
    return price;
  } catch (error) {
    return false;
  }
};

/**
 * Cancel Stripe Payment
 * @param {session_id} payload
 */
export const cancelStripePayment = async (payload) => {
  try {
    await axios.post("/payments/stripe/cancel", payload);

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Get Products
 * @param {page} payload
 */
export const getProducts = async (payload) => {
  try {
    const { data } = await axios.get("/shop/products", {
      params: payload,
    });

    //
    let products = data.data;
    let lastPage = data.meta.last_page;
    let currentPage = data.meta.current_page;
    let total = data.meta.total;

    //
    return { products, lastPage, currentPage, total };
  } catch (error) {
    return false;
  }
};

/**
 * Get MY Products
 * @param {page} payload
 */
export const getMyProducts = async (payload) => {
  try {
    const { data } = await axios.get("/shop/myProducts", {
      params: payload,
    });

    //
    let products = data.data;
    let lastPage = data.last_page;
    let currentPage = data.current_page;
    let total = data.total;

    //
    return { products, lastPage, currentPage, total };
  } catch (error) {
    return false;
  }
};

/**
 * Change Like
 * @param {product_id}
 */
export const changeLike = async (payload) => {
  try {
    await axios.post(`/shop/products/${payload}/like`);

    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Get Product Detail
 * @param {product_id} payload
 */
export const getProductDetail = async (payload) => {
  try {
    const { data } = await axios.get(`/shop/products/${payload}`);

    //
    let product = data.result;

    //
    return product;
  } catch (error) {
    return false;
  }
};

/**
 * Get Product Comments
 * @param {product_id, page} payload
 */
export const getProductComments = async (payload) => {
  try {
    const { data } = await axios.get(`/shop/products/${payload.id}/comments`, {
      params: {
        page: payload.page,
        perPage: 10,
      },
    });

    //
    let comments = data.data;
    let lastPage = data.meta.last_page;
    let currentPage = data.meta.current_page;

    //
    return { comments, lastPage, currentPage };
  } catch (error) {
    return false;
  }
};

/**
 * Store New Product Comment
 * @param {product_id, comment} payload
 */
export const storeComment = async (payload) => {
  try {
    await axios.post(`/shop/products/${payload.id}/comments`, payload.content);

    //
    toast.success("Your comment will be displayed after approval", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return true;
  } catch (error) {
    return false;
  }
};
